interface CredEligibiltyTransformerType {
	eligible: boolean,
    credOffer: string,
    credFlow: string,
}

export const credEligibiltyTransformer = (response: CredEligibiltyTransformerType) => ({
	eligible: response.eligible,
	credOffer: response.credOffer,
	credFlow: response.credFlow,
});
